/* eslint-disable */
export default {
  ringing: 'Saapuva puhelu',
  callConnected: 'Puhelu yhdistetty',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
